/**
 * src/modules/_tekst-wiadomosci.ts — treść wiadomości (zwykły tekst) do HTML z zachowaniem nowych linii.
 *
 * Właściciel 26.10.2026: odpowiedzi i opisy w czacie dyskusji/reklamacji „zlewały się” — „Opis problemu”
 * kupującego wstawiany był bez zamiany \n, więc akapity znikały. Najpierw escape (XSS), potem każda
 * nowa linia (\n, \r\n, samo \r) → <br>. Czysta funkcja — test w tests/frontend/tekst-wiadomosci.test.mjs.
 */

export function tekstWiadomosciHtml(s: any): string {
  return String(s == null ? '' : s)
    .replace(/[&<>"']/g, (c: string) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string))
    .replace(/\r\n?|\n/g, '<br>');
}
